import { useEffect, useState } from 'react';
import {
  Box,
  Card,
  Typography,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  Chip,
  Button,
} from '@mui/material';
import {
  Close,
  ArrowBack,
  LocationOn,
} from '@mui/icons-material';  
import NewUserCard from './NewUserCard';
import ChatInitiation from './ChatInitiation';
import BotSelection from './BotSelection';
import BotUserProfile from '../BotUserProfile';
import { timeAgo } from '../../../utils/dateTime';
import { getBotUsers } from '../../../api/user';
import useSocket from '../../../hooks/useSocket';
import { toast } from 'react-toastify';
import { getAvatarByGender } from '../../../utils/CommonUtils';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// Mock data
 

// const bots = [
//   { id: '1', username: '@Alexander001', distance: '5 km away', images: ["/assets/images/user-profile/fancy-images/img1.jpg"], hasStatus: true },
//   { id: '2', username: '@SarahB21', distance: '8 km away', images: ["/assets/images/user-profile/fancy-images/img2.jpg"] },
//   { id: '3', username: '@JamesW9n', distance: '12 km away', images: ["/assets/images/user-profile/fancy-images/img3.jpg"] },
//   { id: '4', username: '@MichaelT12', distance: '15 km away', images: ["/assets/images/user-profile/fancy-images/img4.jpg"] },
// ];

export default function MUIBasedPortfolio({
  hideHeader = false,   // NEW PROP
  onBack,
  onClose,
  setStep, 
  step,
  onBotClick,
  onRealUserClick,
  isModalOpen,
}) {
  // const [step, setStep] = useState(1);
  const [selectedBot, setSelectedBot] = useState(null);
  const [botDistance, setBotDistance] = useState([40]);
  const [messageTemplate, setMessageTemplate] = useState('');
  const [searchQuery, setSearchQuery] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [bots,setBots] = useState([])
  const [loadingBots,setLoadingBots] = useState(false)
  const { socket, sendMessage, } = useSocket();
 
  const steps = ['Search User', 'Select Bot', 'Initiate Chat'];

  // --- SAME LOGIC AS BEFORE ---
  const handleClose = () => {
    setStep(1);
    setSelectedBot(null);
    setSelectedUser(null);
    setMessageTemplate('');
    setBotDistance([40]);
    setSearchQuery('');
    if (onClose) onClose();    // <<< send event back to modal
  };

  const handleUserSelect = (user) => {
    setSelectedUser(user)
   setStep(2);
  };

  const handleBotSelect = (bot) => {
    setSelectedBot(bot);
    setStep(3);
    setMessageTemplate('')
  };

  const handleCancel = () => {
    setStep(2);
    setSelectedBot(null);
    setMessageTemplate('');
  };

  // const handleInitiateChat = () => {
  //   console.log('Initiating chat with bot:', selectedBot);
  //   console.log('Message template:', messageTemplate);
  //   console.log('Selected user:', selectedUser);
  //   handleClose();
  // };

    const handleInitiateChat = (scheduledDateTime = null) => {
      if (messageTemplate.trim() === '') return;
  
      const messageData = {
        senderId: selectedBot.userId,
        receiverId: selectedUser._id,
        roomId: null,
        message: messageTemplate,
        messageType: 'text',
        files: [],
        userAgentSent: null,
        scheduledDateTime: scheduledDateTime,
        schedule: scheduledDateTime ? true : false
      };
      sendMessage(messageData);
      toast.success('Message sent successfully');
      onClose();
    };

      useEffect(() => {
        const fetchBots = async () => {
          try {
            setLoadingBots(true)
            const response = await getBotUsers(selectedUser?._id, botDistance,selectedUser?.preferences?.gender?.[0]);
            setBots(response.data);
            // setTotalCount(response.count);
          } catch (error) {
            console.error('Error fetching bots:', error);
          }
          setLoadingBots(false)
        };
        if (selectedUser?._id) fetchBots();
      }, [selectedUser?._id, botDistance]);

      useEffect(()=>{
        setSelectedUser(null)
        setSelectedBot(null)
      },[isModalOpen])
  
  return (
    <Box sx={{ p: 0 }}>
      {/* REMOVE HEADER COMPLETELY */}
      
      {/* CONTENT ONLY */}
      <NewUserCard 
        isShow={step === 1}
        onSelect={handleUserSelect}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onRealUserClick={onRealUserClick}
      />
      {/* {step === 1 && (
      )} */}

      {step === 2 && selectedUser && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Selected User Card */}
              <Card sx={{ borderRadius: 3, border: '1px solid', borderColor: '#916008', bgcolor: 'rgba(25, 118, 210, 0.04)' }}>
                <Box sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flex: 1 }}>
                      {/* Avatar with status */}
                      <Box sx={{ position: 'relative' }}>
                        <img 
                           src={selectedUser?.profilePicture || getAvatarByGender(selectedUser?.gender)}
                          alt={(selectedUser?.firstName ?? selectedUser?.userName) || 'User'} 
                          style={{ 
                            width: 72, 
                            height: 72, 
                            borderRadius: '50%',
                            objectFit: 'cover'
                          }} 
                        />
                        <Box 
                          sx={{ 
                            position: 'absolute', 
                            bottom: 2, 
                            right: 2, 
                            width: 16, 
                            height: 16, 
                            bgcolor: selectedUser?.isOnLine ? 'success.main' : 'grey.500',
                            borderRadius: '50%',
                            border: '2px solid white'
                          }} 
                        />
                      </Box>

                      {/* User Info */}
                      <Box sx={{ flex: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center',justifyItems:'center', gap: 2, mb: 1}}>
                          <Typography sx={{   color: '#3C4043', fontSize:'18px', fontWeight:'500', }}>
                            {selectedUser?.firstName ?? selectedUser?.userName}
                          </Typography> 
                          <Box sx={{color:selectedUser?.appInstalled ?  '#108523' : '#fc2323',display: 'flex', alignItems: 'center', gap: 2}}>{selectedUser?.appInstalled ? <Box><CheckCircleIcon sx={{color:'#09a323'}}/> App Installed</Box> : <Box><CancelIcon/>App Not Installed</Box>}</Box>
                          </Box>
						    {selectedUser?.isSubscribed && (
											<Chip
												label={selectedUser?.subscriptionPlan === "Gold" ? "Gold" : "Luxury"}
												size="small"
												sx={{
												background:
													selectedUser?.subscriptionPlan === "Gold"
													? 'linear-gradient(45deg, #916008, #cc9933)'
													: 'linear-gradient(90deg, rgb(176, 37, 33) 0%, rgb(234, 67, 53) 100%)',
												color: 'white',
												fontSize: '12px',
												height: 25
												}}
											/>
											)}
                        </Box>
                        
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                          <LocationOn sx={{ fontSize: 16, color: 'text.secondary' }} />
                          <Typography variant="body2" sx={{ fontFamily: 'Neue Montreal, sans-serif', color: 'text.secondary' }}>
                             {[selectedUser?.city, selectedUser?.state, selectedUser?.country].filter(Boolean)?.length ? [selectedUser?.city, selectedUser?.state, selectedUser?.country].filter(Boolean).join(", ") : 'Location not specified'}
                            {/* {(selectedUser?.city || selectedUser?.state || selectedUser?.country) ? `${selectedUser?.city} ${selectedUser?.state} ${selectedUser?.country}` : 'Location not specified'} */}
                          </Typography>
                        </Box>
                        
                        {/* <Typography variant="body2" sx={{ fontFamily: 'Neue Montreal, sans-serif', color: 'text.secondary' }}>
                          {selectedUser.status}
                        </Typography> */}
                      </Box>
                    </Box>

                    {/* Selected Badge */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
                      {/* <Chip 
                        label="Selected"   
                        size="small"
                        sx={{ fontWeight: '500', background:'#916008', color:'#fff' }}
                      /> */}
                      <Typography variant="caption" color="text.secondary">
                    {selectedUser?.isOnLine
                      ? 'Online'
                      : selectedUser?.lastActive
                        ? timeAgo(selectedUser?.lastActive)
                        : 'Recently active'}
                      </Typography>
                      <Button onClick={()=>onRealUserClick(true,selectedUser)} sx={{textTransform:'capitalize', fontSize:'12px', background:'#BE1F1F', color:'#fff', borderRadius:'20px', px:2, '&:hover': { background: '#ff4A4A' }}}>View Profile</Button>
                    </Box>
                  </Box>
                </Box>
              </Card>

              {/* Bot Selection */}
              <BotSelection
                bots={bots}
                loadingBots={loadingBots}
                selectedBot={selectedBot}
                onBotSelect={handleBotSelect}
                botDistance={botDistance}
                setBotDistance={setBotDistance}
                selectedUserName={selectedUser?.firstName ?? selectedUser?.userName}
                selectedUserId={selectedUser?._id}
                onBotClick={onBotClick}
                onBotViewButtonClick={(bot)=> onBotClick(true,bot)}
              />
            </Box>
      )}

      {step === 3 && selectedBot && selectedUser && (
        <ChatInitiation
          selectedBot={selectedBot}
          selectedUser={selectedUser}
          botDistance={botDistance}
          setBotDistance={setBotDistance}
          messageTemplate={messageTemplate}
          setMessageTemplate={setMessageTemplate}
          onCancel={handleCancel}
          onInitiateChat={handleInitiateChat}
          onBotClick={onBotClick}
          onRealUserClick={()=> onRealUserClick(true,selectedUser)}
          selectedUserId={selectedUser?._id}
           onBotViewButtonClick={(bot)=> onBotClick(true,bot)}
        />
      )}

    </Box>
  );
}
